var _rect, _text, _rect2, _text2, _text3, _rect3, _text4, _rect4, _text5, _text6, _rect5, _text7, _text8, _rect6, _text9, _text10, _rect7, _text11, _text12, _rect8, _text13, _text14, _text15, _rect9, _text16, _text17, _rect10, _text18, _text19, _text20, _text21, _rect11, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _rect12, _text30, _text31, _rect13, _text32, _text33, _text34, _text35, _circle, _text36, _circle2, _text37, _line, _circle3, _text38, _line2, _circle4, _text39, _path, _text40, _line3, _circle5, _text41, _circle6, _text42, _text43, _text44, _text45, _polyline, _polyline2, _line4, _text46, _rect14, _text47, _text48, _text49, _text50, _text51, _rect15, _text52, _text53, _text54, _text55, _text56, _text57, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTracingVsSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 820 580",
    fontFamily: "'Open Sans', Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 820,
    height: 580,
    fill: "#0C0C0C"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 28,
    textAnchor: "middle",
    fill: "#DCCA87",
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: 0.5
  }, "DISTRIBUTED TRACING vs. SESSION-NATIVE OBSERVABILITY")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 45,
    width: 385,
    height: 520,
    rx: 6,
    fill: "none",
    stroke: "#555555",
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 68,
    textAnchor: "middle",
    fill: "#888888",
    fontSize: 12,
    fontWeight: 600
  }, "DISTRIBUTED TRACING")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 84,
    textAnchor: "middle",
    fill: "#666666",
    fontSize: 9
  }, "(What it sees for a 47-call agent session)")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 98,
    width: 345,
    height: 155,
    rx: 4,
    fill: "#141414",
    stroke: "#333333",
    strokeWidth: 1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 116,
    fill: "#888888",
    fontSize: 9,
    fontWeight: 600
  }, "SPAN LIST")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 124,
    width: 320,
    height: 16,
    rx: 2,
    fill: "#1a2a1a",
    stroke: "#2a4a2a",
    strokeWidth: 0.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 135,
    fill: "#4fa54f",
    fontSize: 8
  }, "200")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 135,
    fill: "#aaaaaa",
    fontSize: 8
  }, "span-01  tools/call  fetch_file        4.2K tok   120ms")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 143,
    width: 320,
    height: 16,
    rx: 2,
    fill: "#1a2a1a",
    stroke: "#2a4a2a",
    strokeWidth: 0.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 154,
    fill: "#4fa54f",
    fontSize: 8
  }, "200")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 154,
    fill: "#aaaaaa",
    fontSize: 8
  }, "span-02  tools/call  analyze_code      8.1K tok   340ms")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 162,
    width: 320,
    height: 16,
    rx: 2,
    fill: "#1a2a1a",
    stroke: "#2a4a2a",
    strokeWidth: 0.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 173,
    fill: "#4fa54f",
    fontSize: 8
  }, "200")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 173,
    fill: "#aaaaaa",
    fontSize: 8
  }, "span-22  tools/call  code_analysis    12.0K tok   510ms")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 181,
    width: 320,
    height: 16,
    rx: 2,
    fill: "#1a2a1a",
    stroke: "#2a4a2a",
    strokeWidth: 0.5
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 192,
    fill: "#4fa54f",
    fontSize: 8
  }, "200")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 192,
    fill: "#aaaaaa",
    fontSize: 8
  }, "span-23  llm/call    self-delegate    45.0K tok   890ms")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 200,
    width: 320,
    height: 16,
    rx: 2,
    fill: "#1a2a1a",
    stroke: "#2a4a2a",
    strokeWidth: 0.5
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 211,
    fill: "#4fa54f",
    fontSize: 8
  }, "200")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 211,
    fill: "#aaaaaa",
    fontSize: 8
  }, "span-35  llm/call    self-delegate   180.0K tok  2100ms")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 230,
    textAnchor: "middle",
    fill: "#666666",
    fontSize: 8
  }, "... 42 more spans, all status 200 ...")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 236,
    width: 320,
    height: 16,
    rx: 2,
    fill: "#1a2a1a",
    stroke: "#2a4a2a",
    strokeWidth: 0.5
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 247,
    fill: "#4fa54f",
    fontSize: 8
  }, "200")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 247,
    fill: "#aaaaaa",
    fontSize: 8
  }, "span-47  llm/call    generate_report  22.0K tok   650ms")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 268,
    width: 345,
    height: 70,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#333333",
    strokeWidth: 1
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 286,
    fill: "#888888",
    fontSize: 9,
    fontWeight: 600
  }, "WHAT YOU CAN SEE")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 302,
    fill: "#4fa54f",
    fontSize: 9
  }, "&#x2713; Per-call latency, token count, status code")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 316,
    fill: "#4fa54f",
    fontSize: 9
  }, "&#x2713; Which tool was called with what arguments")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 330,
    fill: "#4fa54f",
    fontSize: 9
  }, "&#x2713; Parent-child structural relationships")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 348,
    width: 345,
    height: 125,
    rx: 4,
    fill: "#2e1a1a",
    stroke: "#6a3a3a",
    strokeWidth: 1
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 366,
    fill: "#c44a4a",
    fontSize: 9,
    fontWeight: 600
  }, "WHAT YOU CANNOT SEE")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 384,
    fill: "#aa7777",
    fontSize: 9
  }, "&#x2717; Why context grew from 12K to 180K (invisible between spans)")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 400,
    fill: "#aa7777",
    fontSize: 9
  }, "&#x2717; That span-22 output was malformed (status was still 200)")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 416,
    fill: "#aa7777",
    fontSize: 9
  }, "&#x2717; That span-23 was caused by span-22 (siblings, not parent-child)")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 432,
    fill: "#aa7777",
    fontSize: 9
  }, "&#x2717; That governance instructions were lost to compaction at #30")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 448,
    fill: "#aa7777",
    fontSize: 9
  }, "&#x2717; That the loop at #23 is the root cause of cost spike at #35")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 464,
    fill: "#aa7777",
    fontSize: 9
  }, "&#x2717; What information was absent that should have been present")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 495,
    textAnchor: "middle",
    fill: "#888888",
    fontSize: 9
  }, "Investigation time: hours (read 47 spans manually)")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 45,
    width: 385,
    height: 520,
    rx: 6,
    fill: "none",
    stroke: "#DCCA87",
    strokeWidth: 1,
    strokeOpacity: 0.4
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 612,
    y: 68,
    textAnchor: "middle",
    fill: "#DCCA87",
    fontSize: 12,
    fontWeight: 600
  }, "SESSION-NATIVE OBSERVABILITY")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 612,
    y: 84,
    textAnchor: "middle",
    fill: "#999966",
    fontSize: 9
  }, "(What it sees for the same 47-call session)")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 98,
    width: 345,
    height: 200,
    rx: 4,
    fill: "#141414",
    stroke: "#4a4a2d",
    strokeWidth: 1
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 116,
    fill: "#DCCA87",
    fontSize: 9,
    fontWeight: 600
  }, "EXECUTION GRAPH WITH CAUSAL EDGES")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 136,
    textAnchor: "middle",
    fill: "#c44a4a",
    fontSize: 8,
    fontStyle: "italic"
  }, "malformed")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 136,
    textAnchor: "middle",
    fill: "#c44a4a",
    fontSize: 8,
    fontStyle: "italic"
  }, "self-deleg")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 136,
    textAnchor: "middle",
    fill: "#c44a4a",
    fontSize: 8,
    fontStyle: "italic"
  }, "explosion")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 155,
    r: 9,
    fill: "#1a2a1a",
    stroke: "#4fa54f",
    strokeWidth: 1.5
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 158,
    textAnchor: "middle",
    fill: "#4fa54f",
    fontSize: 8
  }, "1")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 505,
    cy: 155,
    r: 9,
    fill: "#1a2a1a",
    stroke: "#4fa54f",
    strokeWidth: 1.5
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 159,
    textAnchor: "middle",
    fill: "#4fa54f",
    fontSize: 7
  }, "...")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 514,
    y1: 155,
    x2: 528,
    y2: 155,
    stroke: "#4fa54f",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 155,
    r: 11,
    fill: "#4a2d2d",
    stroke: "#c44a4a",
    strokeWidth: 2
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 159,
    textAnchor: "middle",
    fill: "#c44a4a",
    fontSize: 8,
    fontWeight: 700
  }, "22")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 551,
    y1: 155,
    x2: 605,
    y2: 155,
    stroke: "#c44a4a",
    strokeWidth: 2.5,
    markerEnd: "url(#arrowRed)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 155,
    r: 11,
    fill: "#4a2d2d",
    stroke: "#c44a4a",
    strokeWidth: 2
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 159,
    textAnchor: "middle",
    fill: "#c44a4a",
    fontSize: 8,
    fontWeight: 700
  }, "23")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M620 166 C620 186, 650 190, 660 180 C670 170, 665 165, 655 168",
    fill: "none",
    stroke: "#c4a832",
    strokeWidth: 2,
    strokeDasharray: "4,3"
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 185,
    fill: "#c4a832",
    fontSize: 8,
    fontWeight: 600
  }, "loop")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 631,
    y1: 155,
    x2: 705,
    y2: 155,
    stroke: "#c44a4a",
    strokeWidth: 2,
    markerEnd: "url(#arrowRed)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 155,
    r: 11,
    fill: "#4a2d2d",
    stroke: "#c44a4a",
    strokeWidth: 2
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 159,
    textAnchor: "middle",
    fill: "#c44a4a",
    fontSize: 8,
    fontWeight: 700
  }, "35")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 755,
    cy: 155,
    r: 9,
    fill: "#1a2a1a",
    stroke: "#4fa54f",
    strokeWidth: 1.5
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 755,
    y: 159,
    textAnchor: "middle",
    fill: "#4fa54f",
    fontSize: 7
  }, "...")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 208,
    fill: "#DCCA87",
    fontSize: 8,
    fontWeight: 600
  }, "CONTEXT EVOLUTION")), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 225,
    fill: "#666666",
    fontSize: 7
  }, "180K")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 282,
    fill: "#666666",
    fontSize: 7
  }, "12K")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "475,278 510,276 540,274 570,272 600,269 630,266 660,264 690,262 720,260 750,258 770,256",
    fill: "none",
    stroke: "#4a6fa5",
    strokeWidth: 1.5,
    strokeOpacity: 0.7
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "475,278 510,276 535,274 540,270 545,265 560,255 580,240 600,230 620,225 640,222 660,226 690,235 720,246 750,254 770,256",
    fill: "none",
    stroke: "#c44a4a",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 610,
    y1: 222,
    x2: 610,
    y2: 225,
    stroke: "#c44a4a",
    strokeWidth: 1,
    strokeDasharray: "2,2"
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 615,
    y: 218,
    fill: "#c44a4a",
    fontSize: 7,
    fontWeight: 600
  }, "180K")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 310,
    width: 345,
    height: 95,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#4a4a2d",
    strokeWidth: 1
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 328,
    fill: "#DCCA87",
    fontSize: 9,
    fontWeight: 600
  }, "WHAT YOU CAN SEE")), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 346,
    fill: "#DCCA87",
    fontSize: 9
  }, "&#x2713; Context evolution across all 47 calls (growth + loss)")), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 362,
    fill: "#DCCA87",
    fontSize: 9
  }, "&#x2713; Informational causality (#22 output &#x2192; #23 decision)")), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 378,
    fill: "#DCCA87",
    fontSize: 9
  }, "&#x2713; Self-delegation loop detected at depth 3")), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 394,
    fill: "#DCCA87",
    fontSize: 9
  }, "&#x2713; Root cause: malformed output at #22, not cost spike at #35")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 415,
    width: 345,
    height: 100,
    rx: 4,
    fill: "#1a2e1a",
    stroke: "#4fa54f",
    strokeWidth: 1
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 433,
    fill: "#4fa54f",
    fontSize: 9,
    fontWeight: 600
  }, "LLM-POWERED ROOT CAUSE")), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 452,
    fill: "#ffffff",
    fontSize: 9,
    fontStyle: "italic"
  }, "&quot;Cost spike at event #35 (180K tokens) was caused")), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 468,
    fill: "#ffffff",
    fontSize: 9,
    fontStyle: "italic"
  }, "by self-delegation loop initiated at #23, triggered")), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 484,
    fill: "#ffffff",
    fontSize: 9,
    fontStyle: "italic"
  }, "by malformed tool output at #22 (code_analysis")), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 500,
    fill: "#ffffff",
    fontSize: 9,
    fontStyle: "italic"
  }, "returned truncated JSON, interpreted as incomplete).&quot;")), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    x: 612,
    y: 535,
    textAnchor: "middle",
    fill: "#DCCA87",
    fontSize: 9
  }, "Investigation time: &lt;5 minutes (3 causal nodes + explanation)")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrowRed",
    markerWidth: 8,
    markerHeight: 8,
    refX: 7,
    refY: 4,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,4 L0,8 Z",
    fill: "#c44a4a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracingVsSession);
export default __webpack_public_path__ + "static/media/tracing-vs-session.327af6d214a5363b9ca4b96298b2c755.svg";
export { ForwardRef as ReactComponent };